import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';

export const documentUploadAPI = createApi({
  reducerPath: 'uploadDocs',
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    uploadChatDocs: builder.mutation({
      query: ({
        file,
        borrowerId,
        loanApplicationId,
        title,
        tags,
        chatId,
        fileRequestText,
        useConsumerChatWorkflow = false,
        useB2BChatWorkflow = false,
      } = {}) => {
        const formData = new FormData();
        formData.append('file', file);

        if (loanApplicationId) {
          formData.append('loan_application_id', loanApplicationId);
        }
        if (borrowerId) {
          formData.append('borrower_id', borrowerId);
        }
        if (title) {
          formData.append('title', title);
        }
        if (Array.isArray(tags) && tags.length > 0) {
          formData.append('tags', tags.join(','));
        }
        if (chatId) {
          formData.append('chat_id', chatId);
        }
        if (fileRequestText) {
          formData.append('file_request_text', fileRequestText);
        }

        const headers = getHeaders();
        // Let the browser set proper multipart boundaries
        delete headers['Content-Type'];
        delete headers['content-type'];

        return {
          url: useConsumerChatWorkflow
            ? 'b2c/documents/chat/upload'
            : useB2BChatWorkflow
              ? 'b2b/documents/chat/upload'
              : 'b2c/documents/upload',
          method: 'POST',
          headers,
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadChatDocsMutation } = documentUploadAPI;
